import { render } from "./ProductBestSeller.vue?vue&type=template&id=808bb392&scoped=true"
import script from "./ProductBestSeller.vue?vue&type=script&lang=js"
export * from "./ProductBestSeller.vue?vue&type=script&lang=js"

import "./ProductBestSeller.vue?vue&type=style&index=0&id=808bb392&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-808bb392"]])

export default __exports__